import { useMutation } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useStartChallenge = () => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async (challengeData) => {
      const result = await restClient({
        url: `${prefix}/challenge/start`,
        method: 'post',
        data: challengeData
      });
      return result;
    },
  });
};